/**
 * Action button types
 */
export enum ActionButtonType {
  DELETE = 'delete',
  REDIRECT = 'redirect',
  EDIT = 'edit',
  MODAL = 'modal',
}
